import { useFilters } from '../../../store';
import { options } from './config';
import Filter from './filter.icon.svg';
import css from './filters.module.scss';

export function Filters() {
    const { category, setCategory } = useFilters();
    const filter = options[category];

    return (
        <select
            className={css.select}
            value={filter.value}
            style={{ color: filter.color }}
            onChange={e => setCategory(e.target.value as typeof category)}
        >
            <button>
                <Filter />
            </button>

            {Object.entries(options).map(([value, opt]) => (
                <option key={value} className={css.option} value={value}>
                    <span style={{ color: opt.color }}>{opt.icon}</span>
                    {opt.label}
                </option>
            ))}
        </select>
    );
}
